import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { ConfirmationService } from "primeng/api";
import { take } from "rxjs/operators";
import { AuthService } from "src/app/auth-section/auth-service/auth.service";
import { DocLocalService } from "src/app/doctor-section/doctor-service/doc-local.service";
import { LabService } from "../lab-services/lab.service";

@Component({
  selector: "app-lab",
  templateUrl: "./lab.component.html",
  styleUrls: ["./lab.component.css"],
  providers: [ConfirmationService],
})
export class LabComponent implements OnInit {
  count = 1;
  isData = false;
  searchQuery = null;
  token: string;
  labArray = [];
  filter;
  page = 1;
  totalItems = 0;
  config: { itemsPerPage: number; currentPage: number; totalItems: number };
  allTotal: number = 0;
  isSearch: boolean = false;
  labid: any;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private labService: LabService,
    private authService: AuthService,
    private conformationService: ConfirmationService,
    private activateRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.authService.authDataSubject.pipe(take(1)).subscribe((res) => {
      this.token = res._token;
    });
    this.getlabFromDb("1");
    this.initConfig();
  }
  onAddlab() {
    this.router.navigate(["addlab"], {
      relativeTo: this.activatedRoute,
    });
  }
  onlabClicked(index) {
    this.router.navigate(["profile"], {
      relativeTo: this.activatedRoute,
      queryParams: { id: index },
    });
  }
  onUpdatelab(event, index) {
    event.stopPropagation();
    this.router.navigate(["addlab"], {
      relativeTo: this.activatedRoute,
      queryParams: { id: index },
    });
  }
  onDeletelabs(event, index, id) {
    this.conformationService.confirm({
      message: "Are you sure that you want to perform this action?",
      accept: () => {
        this.labService.deletelab(id, this.token).subscribe((res) => {
          this.labArray.splice(index, 1);
        });
        //Actual logic to perform a confirmation
      },
    });
    event.stopPropagation();
  }
  initConfig() {
    this.config = {
      itemsPerPage: 10,
      currentPage: this.page,
      totalItems: this.totalItems,
    };
  }
  pageChanged(event) {
    this.getlabFromDb(this.config.currentPage);
  }

  alet() {
    alert("Harshit");
  }
  

  getlabFromDb(page) {
    this.labService.getlabFromDb(this.token, page).subscribe((res) => {
      this.labArray = res.labs.docs;
      this.isData = this.labArray.length > 0;
      this.config.currentPage = res.labs.page;
      this.config.totalItems = res.labs.total;
    },(error:any)=>{
      alert(error.message);
    });
  }

  onSearchChange(value) {
    /*   if (value) {
      this.searchlab(value, 1);
      this.isSearch = true;
      this.searchQuery = value;
    } else {
      this.labArray = this.dbLocalService.getlabArray();
      this.page = 1;
      this.isSearch = false;
      this.searchQuery = null;
      this.totalItems = this.allTotal;
      this.initConfig();
    }*/
  }
  /* searchlab(value, pageno) {
    this.labService
      .onSearchlab(value, this.token, pageno)
      .subscribe((res) => {
        this.isData = true;
        this.labArray = res.lab;
        console.log(this.labArray);
        this.page = res.page;
        this.totalItems = res.total;
        this.initConfig();
      });
  }*/
}
